import toPromise from 'lib/to-promise';
import utils from 'lib/utils';

var ResourceService = function() {
  this.getResources = function(resourceType, resourceSubType, withoutFiltering = true) {
    const contentId = EF.enrollment.get('contentId');
    //business_resource_contents => include business_resource
    //content_business_policies => include business_policy
    const urls = {
      resource: withoutFiltering ?
                  `${EF.config.get('portalBasePath')}/business_resources.json?filter[content_id]=${encodeURIComponent(contentId)}` :
                  `${EF.config.get('basePath')}/contents/${encodeURIComponent(contentId)}/business_resource_contents.json?include=business_resource&filter[content_id]=${encodeURIComponent(contentId)}`,
      policyresource: withoutFiltering ?
                        `${EF.config.get('portalBasePath')}/business_policies.json?filter[content_id]=${encodeURIComponent(contentId)}` :
                        `${EF.config.get('basePath')}/contents/${encodeURIComponent(contentId)}/content_business_policies.json?include=business_policy&filter[content_id]=${encodeURIComponent(contentId)}`
    };
    urls.nationalresource = urls.resource;
    if(resourceType) {
      return this.fetch(urls[resourceType.toLowerCase()]).then(resources => {
        if(EF.resources) {
          EF.resources.add(new EF.Collections.ResourcesCollection(resources, { enrollment: EF.enrollment }).models);
        } else {
          EF.resources = new EF.Collections.ResourcesCollection(resources, { enrollment: EF.enrollment });
        }
      }).then(() => {
        return new Promise((resolve) => resolve(EF.resources.byTypeSync(resourceType, resourceSubType)));
      });
    } else {
      return new Promise((_resolve, reject) => reject());
    }
  };

  this.loadResources = function(withoutFiltering) {
    return Promise.all([ this.getResources('PolicyResource', null, withoutFiltering), this.getResources('Resource', null, withoutFiltering) ]).then(() => {
      return Promise.resolve(EF.resources);
    });
  }

  this.fetch = function(url) {
    return fetch(url, { credentials: 'include',
      headers: {
        'Authorization': `Bearer ${EF.config.get('jwt')}`
      }
    }).then(function(response) {
      return response.json();
    }).then(function(data) {
      var resources = utils.sanifyJsonApiObject(data.data);

      resources.forEach(r => {
        // HomeRoom emits `requires_e_signature` and lmscompliance emits `esignature`
        if(r.esignature) {
          r.requires_e_signature = true;
        }

        if(r.type === 'content_business_policies') {
          r.type = 'PolicyResource';
        }

        if(r.type === 'content_business_resources') {
          r.type = 'Resource';
        }

        if(r.id && r.type) {
          // Backbone won't allow duplicate ID attributes, this makes the id unique
          // since the collection is of two different mixed types the ID could be the same
          r.id = `${r.type}-${r.id}`;
        }

        if(r.slug) {
          r.sub_type = r.slug;
        }
      });
      return resources;
    });
  };

  this.save = function(resourceItem) {
    return fetch(`${EF.config.get('basePath')}/progress/${EF.enrollment.id}/policy_signatures.json`, {
      body: JSON.stringify({
        data: {
          type: 'policy_signature',
          attributes: {
            // split on first occurance of - to remove the type added for uniqueness
            policy_id: resourceItem.get('id').substring(resourceItem.get('id').indexOf('-') + 1),
            resource_type: 'PolicyResource'
          }
        }
      }),
      credentials: 'include',
      headers: {
        'Authorization': `Bearer ${EF.config.get('accessToken')}`,
        'Content-Type': 'application/vnd.api+json'
      },
      method: 'POST',
      mode: 'cors'
    });
  };
};

module.exports = new ResourceService();
